"use client";

import React from "react";
import { useStoryblokLivePage } from "hooks/useStoryblokLivePage";
// Must stay on the App Router canvas: importing the Pages canvas
// (src/components/WnCMainCanvas) from app/ compiles it — and its dynamic
// imports (full MUI, dtv-marquee, …) — a second time in the app-pages-browser
// layer, and the shared react-loadable-manifest keys then make Pages SSR emit
// BOTH layers' chunks on every prod page (~75 KiB duplicate JS on the homepage).
import { WnCMainCanvasServer } from "../wnc-main-canvas/wnc-main-cnavas.server";

interface SbPreviewCanvasProps {
  pageAdapterProps?: any;
  sbPreviewAllowed: boolean;
  sbRelationResolveKey?: string;
  mainCanvasProps:any
}

export default function SbPreviewCanvas({
  mainCanvasProps,
  pageAdapterProps,
  sbPreviewAllowed,
  sbRelationResolveKey
}: SbPreviewCanvasProps) {
  const { components: liveComponents } = useStoryblokLivePage({
    sbPreviewAllowed,
    pageAdapterProps,
    initialComponents: mainCanvasProps?.components,
    sbRelationResolveKey
  });
  const components = sbPreviewAllowed ? liveComponents : mainCanvasProps?.components || [];

  return (
    <WnCMainCanvasServer
      {...mainCanvasProps}
      components={components}
    />
  );
}
